import { hasUserPasswordProvider } from "services/firebase/auth/ssoProvider";

import useAppVariant from "features/common/hooks/useAppVariant";
import { isNativeAppiOS } from "features/pwa/mobile/ios/utils/isNativeAppiOS";

export default function useShowLoginAndPasswordPageByVariant() {
  const appVariant = useAppVariant();
  const hasPasswordProvider = hasUserPasswordProvider();

  const valuesByVariant = {
    seneca: hasPasswordProvider || !isNativeAppiOS(),
    plurall: hasPasswordProvider,
    goStudentLearning: false
  };

  return valuesByVariant[appVariant];
}
